module.exports = __webpack_public_path__ + "media/images/icons/material/card-3f2ad382d1ea6f2572ab6d6cc5bba34a.svg";